import { AppData } from '@lightningjs/sdk';
import { STANDARD_EXPANSION } from 'support/animations';
import SearchTile from './SearchTile';

const TILE_WIDTH = 402;
const TILE_HEIGHT_COLLAPSED = 226;
const TILE_HEIGHT_EXPANDED = 349;

const ANIMATION_DURATION = 0.5;

export default class ExpandingDetailTile extends SearchTile {
  static override get width() {
    return TILE_WIDTH;
  }

  static override get height() {
    return TILE_HEIGHT_COLLAPSED;
  }

  static override get highlightWidth() {
    return this.width;
  }

  static override get highlightHeight() {
    return this.height;
  }

  static override get expandedHeight() {
    return TILE_HEIGHT_EXPANDED;
  }

  override get hoverHighlightEnabled() {
    return false;
  }

  override set hoverHighlightEnabled(value: boolean) {
    // No-op
  }

  static override _template() {
    const template = super._template();

    return {
      ...template,
      transitions: {
        ...template.transitions,
        ...STANDARD_EXPANSION,
      },
    };
  }

  override _active() {
    super._active();
    this._MediaInfo.patch({ alpha: 0 });

    this._toggleGlobalHoverListener(true);
  }

  override _inactive() {
    super._inactive();

    this._toggleGlobalHoverListener(false);
  }

  override _focus() {
    if (AppData?.device.getIsHovering() && !this.hovered) return;

    this.handleExpansion(true);
  }

  override _unfocus() {
    this.handleExpansion(false);
  }

  override _handleHover(target: any) {
    this.handleExpansion(true);

    return super._handleHover(target);
  }

  override _handleUnhover(target: any) {
    this.handleExpansion(false);
    return super._handleUnhover(target);
  }

  _toggleGlobalHoverListener(enable: boolean) {
    this.baseToggleGlobalHoverListener(
      enable,
      this._onGlobalHoverStateChanged.bind(this),
      'ExpandingDetailTile',
    );
  }

  _onGlobalHoverStateChanged(isHovered: boolean) {
    if (isHovered) {
      this.handleExpansion(this.hovered, true);
    } else {
      // Restores focus to the fixed focus element
      this.handleExpansion(this.hasFocus(), true);
    }
  }

  private handleExpansion(isExpand: boolean, skipAncestorAction = false) {
    // In certain cases, particularly global hover events,
    // Multiple tiles can fire these events simultaneously.  Ignore ancestors in those cases.
    if (!skipAncestorAction) this.fireAncestors('$expandDetailTile', isExpand);
    this.showMedia(isExpand);
  }

  private showMedia(show: boolean) {
    this._MediaInfo.setSmooth('alpha', show ? 1 : 0, {
      duration: show ? ANIMATION_DURATION : 0,
      timingFunction: 'linear',
    });
  }
}
